// @flow

export * from './ittvTheme'
export { default as ittvBrandConfig } from './brand_config.json'
